// extracted by mini-css-extract-plugin
export default {"wrapper":"UiProgressBar_wrapper","alert":"UiProgressBar_alert","inverted":"UiProgressBar_inverted","bar":"UiProgressBar_bar"};